export default __webpack_public_path__ + "static/media/ready-img.68d323b8.jpg";